var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefrigerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1V7.5L13 9.22M8 3L10 4L12 3H8Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 6.00158L13.031 9.25158L13.0414 12.7097M15.9281 5.26953L16.0621 7.50158L17.9281 8.73363L15.9281 5.26953Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 16.0016L13.031 12.7516L10.0414 14.4897M17.9281 13.2695L16.0621 14.5016L15.9281 16.7336L17.9281 13.2695Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V14.5L7 12.78M12 19L10 18L8 19H12Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33984 15.9984L6.96901 12.7484L6.95857 9.29034M4.07189 16.7305L3.93792 14.4984L2.07189 13.2664L4.07189 16.7305Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33984 5.99842L6.96901 9.24842L9.95857 7.51034M2.07189 8.73047L3.93792 7.49842L4.07189 5.26637L2.07189 8.73047Z",
    stroke: "#18A0FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefrigerated);
export default __webpack_public_path__ + "static/media/icon-refrigerated.42565669965a31982f7a1936fc9f6e84.svg";
export { ForwardRef as ReactComponent };